import ufeApi from 'services/api/ufeApi';
import RCPSCookies from 'utils/RCPSCookies';
import store from 'store/Store';
import UUIDv4 from 'utils/UUID';
import Hashing from 'utils/Hashing';

// https://confluence.sephora.com/wiki/pages/viewpage.action?spaceKey=ILLUMINATE&title=Confirm+Close+Account+API

export function confirmCloseAccount(password) {
    let url = '/api/secure/confirmCloseAccount';

    if (RCPSCookies.isRCPSProfileInfoGroupAPIEnabled()) {
        const { login } = store.getState().user;
        const randomNumber = UUIDv4();
        url = '/gway/v2/secure/confirmCloseAccount';

        return Hashing.sha256(randomNumber).then(function (digest) {
            return ufeApi
                .makeRequest('/api/auth/v1/login', {
                    method: 'POST',
                    body: JSON.stringify({
                        password,
                        email: login,
                        randomNumber: digest
                    }),
                    headers: {
                        'Content-type': 'application/json',
                        'x-requested-source': 'web'
                    }
                })
                .then(response => {
                    if (response?.errors) {
                        const errorResponse = {
                            errorMessages: [response.errors[0]?.errorMessage]
                        };

                        return Promise.reject(errorResponse);
                    }

                    return ufeApi
                        .makeRequest(url, {
                            method: 'POST',
                            body: JSON.stringify({ password, email: login }),
                            headers: {
                                'x-requested-source': 'web'
                            }
                        })
                        .then(data => (data.errorCode ? Promise.reject(data) : data));
                });
        });
    }

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify({ password })
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default { confirmCloseAccount };
